var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alarmM",class:_vm.alarmNum == 0 ? 'bgBlue' : 'bgRed'},[_c('img',{staticClass:"alarmLogo",attrs:{"src":_vm.alarmLogo,"alt":""}}),_vm._v(" "),_c('span',{staticClass:"alarmNum"},[_vm._v("告警数:"),_c('span',[_vm._v(_vm._s(_vm.alarmNum == 0 ? "暂无" : _vm.alarmNum))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66d53438","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/subassembly/alarm.vue
// module id = null
// module chunks = 